import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NotificationKindEnum } from '@zaoblako/shared/modules/notification/enums/notification.kind.enum';
import { NotificationService } from '@zaoblako/web/core/services/notification/notification.service';
import { MenuItem } from 'primeng/api';
import { BadgeModule } from 'primeng/badge';
import { MenuModule } from 'primeng/menu';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Component({
  selector: 'crm-lk-eu-notification-icon',
  standalone: true,
  imports: [CommonModule, MenuModule, BadgeModule],
  templateUrl: './lk-eu-notification-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LkEuNotificationIconComponent implements OnInit {
  public unreadCount$: Observable<number>;

  @Input() public isShow = false;

  @Output() public openNotifications = new EventEmitter<void>();
  @Output() public openNotificationsWithType = new EventEmitter<
    NotificationKindEnum.HELPDESK | NotificationKindEnum.PERSONAL | NotificationKindEnum.PASSAGE | 'FAVORITE'
  >();

  public menuItems: MenuItem[] = [
    {
      icon: 'pi pi-user',
      label: 'Личные',
      target: NotificationKindEnum.PERSONAL,
      command: () => {
        this.openNotificationsWithType.emit(NotificationKindEnum.PERSONAL);
      }
    },
    {
      icon: 'pi pi-question-circle',
      label: 'Заявки',
      target: NotificationKindEnum.HELPDESK,
      command: () => {
        this.openNotificationsWithType.emit(NotificationKindEnum.HELPDESK);
      }
    },
    {
      icon: 'pi pi-key',
      label: 'Пропуска',
      target: NotificationKindEnum.PASSAGE,
      command: () => {
        this.openNotificationsWithType.emit(NotificationKindEnum.PASSAGE);
      }
    },
    {
      icon: 'pi pi-star',
      label: 'Избранное',
      command: () => {
        this.openNotificationsWithType.emit('FAVORITE');
      }
    }
  ];

  public constructor(private readonly notificationService: NotificationService) {}

  public ngOnInit(): void {
    this.unreadCount$ = this.notificationService.unreadCount$.pipe(
      tap((unreadCount) => {
        if (unreadCount) {
          this.menuItems = this.menuItems.map((menuItem) => {
            return unreadCount[menuItem.target] ?? 0 > 0
              ? unreadCount[menuItem.target] > 99
                ? { ...menuItem, label: `${menuItem.label.split(' ')[0]} (99+)` }
                : { ...menuItem, label: `${menuItem.label.split(' ')[0]} (${unreadCount[menuItem.target]})` }
              : { ...menuItem, label: menuItem.label.split(' ')[0] };
          });
        }
      }),
      map((unreadCount) => {
        return unreadCount ? unreadCount.HELPDESK + unreadCount.PERSONAL + unreadCount.PASSAGE : 0;
      })
    );
  }

  public openNotificationSidebar(): void {
    this.openNotifications.emit();
  }
}
